/**
 * HemSyd Reviews — ingen app, eget API (crevo.se/hemsyd-reviews).
 * Kräver window.HS_REVIEW_TOKEN + window.HS_REVIEW_API (satta av
 * snippets/hs-review-token.liquid).
 */
(function () {
  'use strict';

  // Svara-funktionen är byggd och backend fungerar, men är avstängd i UI tills
  // vidare (kräver bl.a. inloggningskrav som inte är klart än). Sätt till true
  // för att slå på den igen.
  var REPLIES_ENABLED = false;

  function checkIconSvg() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
  }

  function plusIconSvg() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v8M8 12h8"/></svg>';
  }

  function minusIconSvg() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M8 12h8"/></svg>';
  }

  function heartIconSvg(filled) {
    var fill = filled ? 'currentColor' : 'none';
    return '<svg viewBox="0 0 24 24" fill="' + fill + '" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
  }

  function replyIconSvg() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>';
  }

  function trashIconSvg() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6h14Z"/></svg>';
  }

  function starsSvg(filled) {
    var fill = filled ? 'currentColor' : 'none';
    var stroke = filled ? 'none' : 'currentColor';
    return '<svg width="14" height="14" viewBox="0 0 24 24" fill="' + fill + '" stroke="' + stroke + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 21 12 17.77 5.82 21 7 14.14l-5-4.87 6.91-1.01L12 2z"/></svg>';
  }

  function starsHtml(rating) {
    var rounded = Math.round(rating);
    var html = '<span class="hsReviewStarsRow">';
    for (var i = 1; i <= 5; i++) {
      html += '<span class="hsStar' + (i <= rounded ? ' is-filled' : '') + '">' + starsSvg(i <= rounded) + '</span>';
    }
    html += '</span>';
    return html;
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function initials(name) {
    var parts = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '?';
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  }

  /** "6 dagar sedan" / "3 veckor sedan" / "2 månader sedan" etc. Förväntar ISO8601 med Z (UTC). */
  function formatRelative(iso) {
    var then = new Date(iso).getTime();
    var diffSec = Math.max(0, (Date.now() - then) / 1000);
    var units = [
      [31536000, 'år'],
      [2592000, 'månad', 'månader'],
      [604800, 'vecka', 'veckor'],
      [86400, 'dag'],
      [3600, 'timme', 'timmar'],
      [60, 'minut', 'minuter'],
    ];
    for (var i = 0; i < units.length; i++) {
      var secs = units[i][0];
      var count = Math.floor(diffSec / secs);
      if (count >= 1) {
        var singular = units[i][1];
        var plural = units[i][2] || singular + 'ar';
        return count + ' ' + (count === 1 ? singular : plural) + ' sedan';
      }
    }
    return 'Just nu';
  }

  var LIKED_STORAGE_KEY = 'hsLikedReviews';

  function getLikedIds() {
    try {
      var raw = window.localStorage.getItem(LIKED_STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function markLiked(id) {
    try {
      var liked = getLikedIds();
      if (liked.indexOf(id) === -1) {
        liked.push(id);
        window.localStorage.setItem(LIKED_STORAGE_KEY, JSON.stringify(liked));
      }
    } catch (e) { }
  }

  function unmarkLiked(id) {
    try {
      var liked = getLikedIds().filter(function (x) { return x !== id; });
      window.localStorage.setItem(LIKED_STORAGE_KEY, JSON.stringify(liked));
    } catch (e) { }
  }

  function likeCountLabel(count) {
    return count === 1 ? '1 gillar' : count + ' gillar';
  }

  function handleLikeClick(btn, reviewId) {
    if (btn.disabled) return;
    btn.disabled = true;

    fetch(window.HS_REVIEW_API + '/reviews/like.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ review_id: reviewId }),
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        btn.disabled = false;
        if (!json.ok) {
          console.error('hsReviews: like.php svarade med fel:', json.error);
          return;
        }

        if (json.data.liked) {
          markLiked(reviewId);
          btn.classList.add('is-liked');
        } else {
          unmarkLiked(reviewId);
          btn.classList.remove('is-liked');
        }
        btn.innerHTML = heartIconSvg(json.data.liked) + '<span class="hsReviewLikeCount">' + likeCountLabel(json.data.likes_count) + '</span>';
      })
      .catch(function (err) {
        btn.disabled = false;
        console.error('hsReviews: kunde inte nå like.php:', err);
      });
  }

  function renderStarsWidgets() {
    var widgets = document.querySelectorAll('[data-hs-review-stars]');
    if (!widgets.length) return;

    var ids = [];
    widgets.forEach(function (el) {
      var id = el.getAttribute('data-hs-review-stars');
      if (ids.indexOf(id) === -1) ids.push(id);
    });

    fetch(window.HS_REVIEW_API + '/reviews/summary.php?product_ids=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (!json.ok) return;
        widgets.forEach(function (el) {
          var id = el.getAttribute('data-hs-review-stars');
          var data = json.data[id];
          if (!data) return;
          if (data.review_count === 0) {
            el.innerHTML = '';
            el.hidden = true;
            return;
          }
          el.hidden = false;
          el.innerHTML = starsHtml(data.avg_rating) +
            '<span class="hsReviewAvg">' + data.avg_rating.toFixed(1) + '/5</span>' +
            '<span class="hsReviewCount">(' + data.review_count + ')</span>';
        });
      })
      .catch(function () { });
  }

  function initReviewSection(section) {
    var productId = section.getAttribute('data-hs-review-section');
    var productHandle = section.getAttribute('data-hs-product-handle') || '';
    var summaryEl = section.querySelector('.hsReviewSummary');
    var listEl = section.querySelector('.hsReviewItems');
    var loadMoreWrap = section.querySelector('.hsReviewLoadMoreWrap');
    var page = 1;

    loadSummary();
    loadPage();

    function loadSummary() {
      fetch(window.HS_REVIEW_API + '/reviews/summary.php?product_id=' + productId)
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (!json.ok) return;
          renderSummary(json.data);
        })
        .catch(function () {});
    }

    function renderSummary(data) {
      if (data.review_count === 0) {
        summaryEl.innerHTML = '<p class="hsReviewEmpty">Inga recensioner ännu. Bli först med att recensera!</p>';
        return;
      }
      summaryEl.innerHTML =
        '<div class="hsReviewAvgNum">' + data.avg_rating.toFixed(1).replace('.', ',') + '</div>' +
        starsHtml(data.avg_rating) +
        '<div class="hsReviewBasedOn">Baserat på ' + data.review_count + ' recension' + (data.review_count === 1 ? '' : 'er') + '</div>';
    }

    function loadPage() {
      fetch(window.HS_REVIEW_API + '/reviews/list.php?product_id=' + productId + '&page=' + page)
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (!json.ok) return;
          renderItems(json.data);
        })
        .catch(function () {
          listEl.innerHTML = '<p class="hsReviewEmpty">Kunde inte ladda recensioner just nu.</p>';
        });
    }

    function prosConsLine(text, isPro) {
      if (!text) return '';
      return '<div class="hsReviewProsConsLine ' + (isPro ? 'is-pro' : 'is-con') + '">' +
        (isPro ? plusIconSvg() : minusIconSvg()) +
        '<span>' + escapeHtml(text) + '</span>' +
      '</div>';
    }

    function imagesRowHtml(images) {
      if (!images || !images.length) return '';
      var html = '<div class="hsReviewImagesRow">';
      images.forEach(function (url) {
        html += '<a href="' + escapeHtml(url) + '" target="_blank" rel="noopener" class="hsReviewImageThumb">' +
          '<img src="' + escapeHtml(url) + '" alt="Bild från recension" loading="lazy">' +
        '</a>';
      });
      html += '</div>';
      return html;
    }

    function repliesHtml(replies) {
      if (!replies || !replies.length) return '';
      var html = '<div class="hsReviewReplies">';
      replies.forEach(function (rp) {
        html +=
          '<div class="hsReviewReplyItem">' +
            '<div class="hsReviewReplyAvatar">' + escapeHtml(initials(rp.name)) + '</div>' +
            '<div class="hsReviewReplyBody">' +
              '<div class="hsReviewReplyMeta"><strong>' + escapeHtml(rp.name) + '</strong> · ' + formatRelative(rp.created_at) + '</div>' +
              '<p class="hsReviewReplyText">' + escapeHtml(rp.reply_text) + '</p>' +
            '</div>' +
          '</div>';
      });
      html += '</div>';
      return html;
    }

    function replyFormHtml(reviewId) {
      return (
        '<div class="hsReviewReplyForm" data-hs-reply-form hidden>' +
          '<div class="hsReviewReplyAvatar">A</div>' +
          '<div class="hsReviewReplyFormBody">' +
            '<div class="hsReviewReplyFormRow">' +
              '<input type="text" class="hsReviewReplyNameInput" placeholder="Ditt namn" maxlength="100">' +
              '<input type="email" class="hsReviewReplyEmailInput" placeholder="Din e-post" maxlength="255">' +
            '</div>' +
            '<textarea class="hsReviewReplyTextInput" placeholder="Skriv ett svar..." rows="2" maxlength="1000"></textarea>' +
            '<div class="hsReviewReplyFormFooter">' +
              '<span class="hsReviewReplyMsg" data-hs-reply-msg></span>' +
              '<button type="button" class="hsReviewReplySubmitBtn" data-hs-reply-submit data-id="' + reviewId + '">Skicka</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }

    function wireReplyForm(item, reviewId) {
      var replyToggle = item.querySelector('[data-hs-reply-toggle]');
      var replyForm = item.querySelector('[data-hs-reply-form]');
      var submitBtn = item.querySelector('[data-hs-reply-submit]');

      replyToggle.addEventListener('click', function () {
        replyForm.hidden = !replyForm.hidden;
      });

      submitBtn.addEventListener('click', function () {
        var nameInput = replyForm.querySelector('.hsReviewReplyNameInput');
        var emailInput = replyForm.querySelector('.hsReviewReplyEmailInput');
        var textInput = replyForm.querySelector('.hsReviewReplyTextInput');
        var msgEl = replyForm.querySelector('[data-hs-reply-msg]');

        var name = nameInput.value.trim();
        var email = emailInput.value.trim();
        var replyText = textInput.value.trim();

        msgEl.textContent = '';
        msgEl.className = 'hsReviewReplyMsg';

        if (name.length < 2) {
          msgEl.textContent = 'Ange ditt namn.';
          msgEl.classList.add('is-error');
          return;
        }
        if (replyText.length < 2) {
          msgEl.textContent = 'Skriv ett svar.';
          msgEl.classList.add('is-error');
          return;
        }

        submitBtn.disabled = true;

        fetch(window.HS_REVIEW_API + '/reviews/reply-submit.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            review_id: reviewId,
            name: name,
            email: email || (name.replace(/\s+/g, '.').toLowerCase() + '@ingen-epost.hemsyd.se'),
            reply_text: replyText,
          }),
        })
          .then(function (r) { return r.json(); })
          .then(function (json) {
            submitBtn.disabled = false;
            if (!json.ok) {
              msgEl.textContent = json.error || 'Något gick fel.';
              msgEl.classList.add('is-error');
              return;
            }
            nameInput.value = '';
            emailInput.value = '';
            textInput.value = '';
            msgEl.textContent = 'Ditt svar väntar godkännande innan det publiceras.';
            msgEl.classList.add('is-success');
          })
          .catch(function () {
            submitBtn.disabled = false;
            msgEl.textContent = 'Något gick fel. Försök igen.';
            msgEl.classList.add('is-error');
          });
      });
    }

    function renderItems(data) {
      if (page === 1) listEl.innerHTML = '';

      if (data.items.length === 0 && page === 1) {
        listEl.innerHTML = '<p class="hsReviewEmpty">Inga recensioner ännu. Bli först med att recensera!</p>';
        return;
      }

      var likedIds = getLikedIds();

      data.items.forEach(function (r) {
        var item = document.createElement('div');
        item.className = 'hsReviewItem';

        var alreadyLiked = likedIds.indexOf(r.id) !== -1;
        var likesCount = r.likes_count || 0;

        item.innerHTML =
          '<div class="hsReviewItemHead">' +
            '<div class="hsReviewAvatar">' + escapeHtml(initials(r.name)) + '</div>' +
            '<div class="hsReviewItemName">' +
              escapeHtml(r.name) +
              (r.verified_purchase ? '<span class="hsReviewVerified"><span class="hsReviewVerifiedIcon">' + checkIconSvg() + '</span>Verifierad köpare</span>' : '') +
            '</div>' +
          '</div>' +
          '<div class="hsReviewItemCard">' +
            starsHtml(r.rating) +
            (r.title ? '<p class="hsReviewItemTitle">' + escapeHtml(r.title) + '</p>' : '') +
            '<div class="hsReviewItemTextRow">' +
              (r.review_text ? '<p class="hsReviewItemText">' + escapeHtml(r.review_text) + '</p>' : '<span></span>') +
              '<span class="hsReviewItemDate">' + formatRelative(r.created_at) + '</span>' +
            '</div>' +
            ((r.pros || r.cons) ? '<div class="hsReviewProsConsRow">' + prosConsLine(r.pros, true) + prosConsLine(r.cons, false) + '</div>' : '') +
            imagesRowHtml(r.images) +
            '<div class="hsReviewActionsRow">' +
              '<button type="button" class="hsReviewLikeBtn' + (alreadyLiked ? ' is-liked' : '') + '" data-hs-like-btn data-id="' + r.id + '">' +
                heartIconSvg(alreadyLiked) +
                '<span class="hsReviewLikeCount">' + likeCountLabel(likesCount) + '</span>' +
              '</button>' +
              (REPLIES_ENABLED ?
                '<button type="button" class="hsReviewReplyToggle" data-hs-reply-toggle>' +
                  replyIconSvg() + '<span>Svara</span>' +
                '</button>'
                : '') +
            '</div>' +
            (REPLIES_ENABLED ? repliesHtml(r.replies) : '') +
            (REPLIES_ENABLED ? replyFormHtml(r.id) : '') +
          '</div>';
        listEl.appendChild(item);

        var likeBtn = item.querySelector('[data-hs-like-btn]');
        likeBtn.addEventListener('click', function () {
          handleLikeClick(likeBtn, r.id);
        });

        if (REPLIES_ENABLED) {
          wireReplyForm(item, r.id);
        }
      });

      if (loadMoreWrap) loadMoreWrap.innerHTML = '';
      if (data.has_more && loadMoreWrap) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'hsReviewLoadMore';
        btn.textContent = 'Visa fler recensioner';
        btn.addEventListener('click', function () {
          page++;
          loadPage();
        });
        loadMoreWrap.appendChild(btn);
      }
    }

    var modal = section.querySelector('[data-hs-review-modal]');
    var openBtn = section.querySelector('[data-hs-review-open]');
    var closeBtns = section.querySelectorAll('[data-hs-review-close]');
    var form = section.querySelector('[data-hs-review-form]');
    var steps = section.querySelectorAll('.hsReviewModalStep');
    var ratingButtons = section.querySelectorAll('[data-hs-rate]');
    var ratingInput = section.querySelector('[data-hs-rating-input]');
    var nameInput = form.querySelector('[name="name"]');
    var nameMirror = section.querySelector('[data-hs-name-mirror]');
    var step1Msg = section.querySelector('[data-hs-step1-msg]');
    var step2Msg = section.querySelector('[data-hs-step2-msg]');
    var nextBtn = section.querySelector('[data-hs-next]');
    var prevBtn = section.querySelector('[data-hs-prev]');
    var submitBtn = section.querySelector('[data-hs-submit]');
    var imageInput = section.querySelector('[data-hs-image-input]');
    var imageTrigger = section.querySelector('[data-hs-image-trigger]');
    var imagePreviews = section.querySelector('[data-hs-image-previews]');
    var selectedImages = [];
    var MAX_IMAGES = 3;

    function goToStep(n) {
      steps.forEach(function (s) {
        s.hidden = s.getAttribute('data-hs-step') !== String(n);
      });
    }

    function resetForm() {
      form.reset();
      if (nameInput.value === '' ) nameInput.value = nameInput.defaultValue;
      ratingInput.value = '';
      ratingButtons.forEach(function (b) {
        b.classList.remove('is-filled');
        b.innerHTML = starsSvg(false);
      });
      selectedImages.forEach(function (img) { URL.revokeObjectURL(img.previewUrl); });
      selectedImages = [];
      renderImagePreviews();
      step1Msg.textContent = '';
      step2Msg.textContent = '';
      goToStep(1);
    }

    function openModal() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    if (openBtn) openBtn.addEventListener('click', function () {
      resetForm();
      openModal();
    });
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    (function maybeAutoOpenFromUrl() {
      var params = new URLSearchParams(window.location.search);
      if (params.get('skriv_recension') !== '1') return;

      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(function () {
        resetForm();
        openModal();
      }, 400);
    })();

    ratingButtons.forEach(function (btn, idx) {
      btn.addEventListener('click', function () {
        var val = idx + 1;
        ratingInput.value = val;
        ratingButtons.forEach(function (b, i) {
          b.classList.toggle('is-filled', i < val);
          b.innerHTML = starsSvg(i < val);
        });
      });
    });

    function renderImagePreviews() {
      imagePreviews.innerHTML = '';
      selectedImages.forEach(function (img, idx) {
        var thumb = document.createElement('div');
        thumb.className = 'hsReviewImagePreview' + (img.status === 'uploading' ? ' is-uploading' : '') + (img.status === 'error' ? ' is-error' : '');
        thumb.innerHTML =
          '<img src="' + img.previewUrl + '" alt="">' +
          '<button type="button" class="hsReviewImageRemove" aria-label="Ta bort bild">' + trashIconSvg() + '</button>';
        thumb.querySelector('.hsReviewImageRemove').addEventListener('click', function () {
          selectedImages.splice(idx, 1);
          renderImagePreviews();
        });
        imagePreviews.appendChild(thumb);
      });

      if (imageTrigger) {
        imageTrigger.style.display = selectedImages.length >= MAX_IMAGES ? 'none' : '';
      }
    }

    function uploadImageFile(file) {
      var previewUrl = URL.createObjectURL(file);
      var entry = { file: file, previewUrl: previewUrl, token: null, status: 'uploading' };
      selectedImages.push(entry);
      renderImagePreviews();

      var formData = new FormData();
      formData.append('image', file);

      fetch(window.HS_REVIEW_API + '/reviews/upload-image.php', {
        method: 'POST',
        body: formData,
      })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (!json.ok) {
            entry.status = 'error';
            renderImagePreviews();
            return;
          }
          entry.token = json.data.token;
          entry.status = 'done';
          renderImagePreviews();
        })
        .catch(function () {
          entry.status = 'error';
          renderImagePreviews();
        });
    }

    if (imageTrigger && imageInput) {
      imageTrigger.addEventListener('click', function () {
        imageInput.click();
      });

      imageInput.addEventListener('change', function () {
        var files = Array.prototype.slice.call(imageInput.files || []);
        var room = MAX_IMAGES - selectedImages.length;
        files.slice(0, room).forEach(function (file) {
          if (file.size > 5 * 1024 * 1024) {
            step1Msg.textContent = 'En bild är för stor (max 5 MB): ' + file.name;
            step1Msg.className = 'hsReviewModalMsg is-error';
            return;
          }
          uploadImageFile(file);
        });
        imageInput.value = '';
      });
    }

    nextBtn.addEventListener('click', function () {
      step1Msg.textContent = '';
      var name = nameInput.value.trim();
      if (name.length < 2) {
        step1Msg.textContent = 'Ange ditt namn.';
        step1Msg.className = 'hsReviewModalMsg is-error';
        return;
      }
      if (!ratingInput.value) {
        step1Msg.textContent = 'Välj ett betyg.';
        step1Msg.className = 'hsReviewModalMsg is-error';
        return;
      }
      nameMirror.value = name;
      goToStep(2);
    });

    prevBtn.addEventListener('click', function () {
      goToStep(1);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      step2Msg.textContent = '';

      var consent = section.querySelector('[data-hs-consent]');
      if (!consent.checked) {
        step2Msg.textContent = 'Du måste acceptera riktlinjerna.';
        step2Msg.className = 'hsReviewModalMsg is-error';
        return;
      }

      var name = nameInput.value.trim();
      var email = form.querySelector('[name="email"]').value.trim() || (name.replace(/\s+/g, '.').toLowerCase() + '@ingen-epost.hemsyd.se');
      var reviewText = form.querySelector('[name="review_text"]').value.trim();
      var title = form.querySelector('[name="title"]').value.trim();
      var pros = form.querySelector('[name="pros"]').value.trim();
      var cons = form.querySelector('[name="cons"]').value.trim();
      var rating = Number(ratingInput.value || 0);

      if (reviewText.length > 0 && reviewText.length < 10) {
        step2Msg.textContent = 'Texten måste vara minst 10 tecken (eller lämna tom).';
        step2Msg.className = 'hsReviewModalMsg is-error';
        goToStep(1);
        return;
      }

      submitBtn.disabled = true;

      var imageTokens = selectedImages
        .filter(function (img) { return img.status === 'done' && img.token; })
        .map(function (img) { return img.token; });

      fetch(window.HS_REVIEW_API + '/reviews/submit.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          product_id: productId,
          product_handle: productHandle,
          rating: rating,
          name: name,
          email: email,
          review_text: reviewText || 'Inget omdöme lämnat.',
          title: title,
          pros: pros,
          cons: cons,
          image_tokens: imageTokens,
          token: window.HS_REVIEW_TOKEN
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          submitBtn.disabled = false;
          if (!json.ok) {
            step2Msg.textContent = json.error || 'Något gick fel.';
            step2Msg.className = 'hsReviewModalMsg is-error';
            return;
          }
          goToStep(3);
        })
        .catch(function () {
          submitBtn.disabled = false;
          step2Msg.textContent = 'Något gick fel. Försök igen.';
          step2Msg.className = 'hsReviewModalMsg is-error';
        });
    });
  }

  function bootstrap() {
    renderStarsWidgets();
    document.querySelectorAll('[data-hs-review-section]').forEach(initReviewSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  window.HSReviews = { refreshStars: renderStarsWidgets };
})();
